<div class="tab-list">
	<slot></slot>
</div>

<style>
	.tab-list {
		border-bottom: 1px solid #0d6efd;
	}
</style>